import { gql } from '@apollo/client';

export const REMOVE_FROM_COMPANY = gql`
  mutation RemoveFromCompany($id: ID!) {
    removeFromCompany(id: $id) {
      id
    }
  }
`;